import { render, staticRenderFns } from "./Whistleblowing.vue?vue&type=template&id=7e97cfb5&scoped=true&"
import script from "./Whistleblowing.vue?vue&type=script&lang=js&"
export * from "./Whistleblowing.vue?vue&type=script&lang=js&"
import style0 from "./Whistleblowing.vue?vue&type=style&index=0&id=7e97cfb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e97cfb5",
  null
  
)

export default component.exports